export const OPEN_MODAL = "modals/OPEN_MODAL"
export const CLOSE_MODAL = "modals/CLOSE_MODAL"
export const UPDATE_PARAMS = "modals/UPDATE_PARAMS"
